import type { ReactNode } from 'react'

import type { ParagraphFeedback } from './content-brief.interface'

export interface ContentBriefFeedbackSummaryProps {
  feedbackList: ParagraphFeedback[]
}

export const ContentBriefFeedbackSummary: React.FC<ContentBriefFeedbackSummaryProps> = ({
  feedbackList,
}): ReactNode => (
  <div className="content-brief-feedback-summary max-h-32 overflow-y-auto rounded-md border bg-muted/30 p-3">
    <ul className="space-y-2 text-sm">
      {feedbackList.map((feedback) => (
        <li key={feedback.lineNumber} className="flex gap-2">
          <span className="flex-shrink-0 font-medium text-muted-foreground">
            Line {feedback.lineNumber}:
          </span>
          <span className="break-words text-muted-foreground">{feedback.comment}</span>
        </li>
      ))}
    </ul>
  </div>
)
